import { useEffect, useState } from 'react';

const INITIAL_RESET_KEY = Symbol('initial-reset-key');

export function useInitialLoading(
    loading: boolean,
    resetKey?: unknown,
): boolean {
    const [completedResetKey, setCompletedResetKey] = useState<unknown>(() =>
        loading ? INITIAL_RESET_KEY : resetKey,
    );

    useEffect(() => {
        if (!loading) {
            setCompletedResetKey(resetKey);
        }
    }, [loading, resetKey]);

    return !Object.is(completedResetKey, resetKey);
}
